var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 648 648",
    style: {
      enableBackground: "new 0 0 648 648"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#12173F;}\r\n\t.st1{fill:#5D76A9;}\r\n\t.st2{fill:#707271;}\r\n\t.st3{fill:#FFBB22;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,581.6c0-6.6-5.4-12.1-12.1-12.1h-22.6V612h9.9v-13.3h9.2c2.9,0.1,5.3,2.5,5.3,5.4v7.8h9.9v-7.8 c0-3.5-1.2-6.7-3.1-9.2c2.2-2.2,3.5-5.3,3.5-8.6V581.6z M169.2,579.4c1.2,0,2.2,1,2.2,2.2v4.8c0,1.4-1.1,2.5-2.5,2.5h-12.4v-9.4 H169.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "404.1,612 368.9,612 368.9,569.5 378.8,569.5 378.8,602.1 404.1,602.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "502.1,579.4 502.1,569.5 466.9,569.5 466.9,612 502.1,612 502.1,602.1 476.8,602.1 476.8,595.2  498.6,595.2 498.6,585.3 476.8,585.3 476.8,579.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "279.5,612 241.3,612 263.2,579.4 243.7,579.4 243.7,569.5 281.8,569.5 259.9,602.1 279.5,602.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.9,612 302.7,612 324.6,579.4 305.1,579.4 305.1,569.5 343.2,569.5 321.3,602.1 340.9,602.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.8,
    y: 569.5,
    className: "st0",
    width: 9.9,
    height: 42.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 569.5,
    className: "st0",
    width: 9.9,
    height: 42.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 569.5,
    className: "st0",
    width: 9.9,
    height: 42.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.8,476.4h-36.2v77.8h17.9v-25h18.3c12,0,21.8-9.8,21.8-21.8v-9.2C397.6,486.2,387.8,476.4,375.8,476.4z  M379.7,507.4c0,2.2-1.8,3.9-3.9,3.9h-18.3v-17h18.3c2.2,0,3.9,1.8,3.9,3.9V507.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.3,554.2h-1.5v-69.6h28c7.5,0,13.6,6.1,13.6,13.6v9.2c0,7.5-6.1,13.6-13.6,13.6h-26.5V554.2z M349.3,519.5 h26.5c6.7,0,12.1-5.4,12.1-12.1v-9.2c0-6.7-5.4-12.1-12.1-12.1h-26.5V519.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "237.4,494.3 237.4,476.4 178.4,476.4 178.4,554.2 237.3,554.2 237.3,536.4 196.3,536.4 196.3,524.3  231,524.3 231,506.4 196.3,506.4 196.3,494.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "237.4,486.1 237.4,484.6 186.6,484.6 186.6,546 237.3,546 237.3,544.6 188.1,544.6 188.1,516.1  231,516.1 231,514.6 188.1,514.6 188.1,486.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.3,476.5h-61.7v77.7h17.9v-59.8h14.9v59.9h17.9v-59.9h11c2.2,0,3.9,1.8,3.9,3.9v55.9h17.9v-55.9 C330.1,486.3,320.3,476.5,308.3,476.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.3,484.7h-53.5v69.5h1.5v-68h31.3v68.1h1.5v-68.1h19.2c6.7,0,12.1,5.4,12.1,12.1v55.9h1.5v-55.9 C321.9,490.8,315.8,484.7,308.3,484.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147,476.5H85.3v77.7h17.9v-59.8h14.9v59.9H136v-59.9h11c2.2,0,3.9,1.8,3.9,3.9v55.9h17.9v-55.9 C168.8,486.3,159,476.5,147,476.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147,484.7H93.5v69.5H95v-68h31.3v68.1h1.5v-68.1H147c6.7,0,12.1,5.4,12.1,12.1v55.9h1.5v-55.9 C160.6,490.8,154.5,484.7,147,484.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.5,
    y: 476.4,
    className: "st0",
    width: 17.9,
    height: 77.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.7,
    y: 476.4,
    className: "st1",
    width: 1.5,
    height: 77.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "446.1,476.4 446.1,506.4 423.8,506.4 423.8,476.4 406,476.4 406,554.2 423.8,554.2 423.8,524.3  446.1,524.3 446.1,554.2 463.9,554.2 463.9,476.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "454.2,476.4 454.2,514.6 415.6,514.6 415.6,476.4 414.2,476.4 414.2,554.2 415.6,554.2 415.6,516.1  454.2,516.1 454.2,554.2 455.7,554.2 455.7,476.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,612H97.4c-6.6,0-12.1-5.4-12.1-12.1v-18.3c0-6.6,5.4-12.1,12.1-12.1h10.5c6.6,0,12.1,5.4,12.1,12.1v2 h-9.9v-2c0-1.2-1-2.2-2.2-2.2H97.4c-1.2,0-2.2,1-2.2,2.2v18.3c0,1.2,1,2.2,2.2,2.2h12.7v-3.9h-5.9v-9.9H120V612z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,612H97.4c-6.6,0-12.1-5.4-12.1-12.1v-18.3c0-6.6,5.4-12.1,12.1-12.1h10.5c6.6,0,12.1,5.4,12.1,12.1v2 h-9.9v-2c0-1.2-1-2.2-2.2-2.2H97.4c-1.2,0-2.2,1-2.2,2.2v18.3c0,1.2,1,2.2,2.2,2.2h12.7v-3.9h-5.9v-9.9H120V612z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.4,612h-10.6c-6.6,0-12.1-5.4-12.1-12.1v-1.5h9.9v1.5c0,1.2,1,2.2,2.2,2.2h10.6c1.2,0,2.2-1,2.2-2.2v-1.8 l-18.4-4.9c-3.8-1.2-6.4-4.7-6.4-8.7v-2.6c0-6.8,5.5-12.4,12.4-12.4h10.3c6.6,0,12.1,5.4,12.1,12.1v2h-9.9v-2c0-1.2-1-2.2-2.2-2.2 h-10.3c-1.4,0-2.5,1.1-2.5,2.5v2l18.4,4.9c3.8,1.2,6.4,4.7,6.4,8.7v2.4C562.5,606.6,557.1,612,550.4,612"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.8,554.1h-36.7v-24.7H522v6.9h18.8c2.3,0,4.1-1.8,4.1-4.1v-3.6l-29.2-9c-6.9-2.1-11.6-8.4-11.6-15.6v-5.6 c0-12.1,9.8-22,22-22h36.7v25.7h-17.9v-7.8h-18.8c-2.3,0-4.1,1.8-4.1,4.1v4.5l29.1,8.9c7,2.1,11.7,8.5,11.7,15.8v4.5 C562.7,544.3,552.9,554.1,540.8,554.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.8,545.9h-28.5v-16.6h1.5v15.1h27c6.8,0,12.3-5.5,12.3-12.3v-4.5c0-3-2-5.7-4.9-6.6l-30.1-9.3 c-3.5-1.1-5.8-4.2-5.8-7.8v-5.6c0-7.6,6.2-13.8,13.8-13.8h28.5v17.5H553v-16h-27c-6.8,0-12.3,5.5-12.3,12.3v5.6 c0,3,1.9,5.5,4.7,6.4l30.1,9.3c3.5,1.1,5.9,4.3,5.9,8v4.5C554.5,539.8,548.4,545.9,540.8,545.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.9,131.7c5.4-10.1,7.9-20.3,7.9-30c0-22.2-12.4-42-29.7-53.8c-24.2-16.4-60.4-18.7-86.1,12 c-37.4-5.1-68.9,5.2-80.8,10.1c-11.9-4.9-43.3-15.2-80.8-10.1c-25.7-30.7-62-28.4-86.1-12c-17.4,11.8-29.7,31.6-29.7,53.8 c0,9.7,2.6,19.9,7.9,30c-19.4,27.9-32.8,61.1-32.8,94.8c0,40.6,17.4,61.6,23.9,70.6c0,0,2.8-2.8,5.2-5.2 c18.4,46.8,49.8,72,87.8,94.9c0,0,0.8-4.6,1.6-8.8c40.9,35.4,60.4,26.7,102.9,74.8c42.4-47.9,62.4-39.7,102.9-74.8 c0.8,4.1,1.6,8.8,1.6,8.8c16.9-10.2,64.6-35.8,87.8-94.9c2.4,2.4,5.2,5.2,5.2,5.2c4-5.5,23.9-27.7,23.9-70.6 C545.7,192.8,532.3,159.7,512.9,131.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.2,132.3c39-59.9-49.5-122.2-92.3-61.9c-43.3-7.7-79.8,8.1-84.7,10.4c-4.9-2.3-41.4-18.1-84.7-10.4 c-42.9-60.3-131.3,2-92.3,61.9c-44.4,61-40,121.2-19.4,149.5l8.5-8.5c0,0,12.1,58.8,76.1,97.5l2.3-12.7 c39.4,42.1,75.4,41.1,109.4,79.6c34-38.4,70-37.5,109.4-79.6l2.3,12.7c64-38.6,76.1-97.5,76.1-97.5l8.5,8.5 C541.3,253.4,545.7,193.4,501.2,132.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.6,356.2c0,0-30.7,0.5-35.3,3.3c0,0-5.3,9.1,35.3,9c38.6-0.2,32.9-7.2,33.2-8.3 C357.8,360.2,344.8,356.2,324.6,356.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298,320.5c0,0,4.8-13.9,9.9-9.5c7.1,6.1,16.3,18.5,16.3,19.8v16.5l-11.2,0.6c-6.4,0.2-27.2,5.1-27.2,5.1 c-28.6-70.8-12.7-124.3-5.1-143.5c-28.3,6.1-32.9-27.9-32.9-27.9c2.9-0.6,7.3,0.7,12.2,3c7.6,3.6,16.5,9.8,23.6,15.3h0 c2.1,1.6,4,3.2,5.8,4.7c19.3,16.2,34.9,12.9,34.9,12.9v69.3C324.2,286.9,268,282.5,298,320.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.7,320.5c35.8-36.3-22.6-34.2-26.3-33.6C330.4,287.2,375.6,287.5,350.7,320.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.4,210.7c32.2,86.7-8.6,142.5-8.9,142.8c25.3-66.4,9.1-121.5-2-142c-5.7,0.6-12.5,0.2-12.5,0.2 s8.6-5.3,14.1-10.3c0.4-0.4,0.8-0.7,1.3-1.2c4.6-4.1,13.4-11.3,24.1-15.4h0c3.9-1.5,8.1-2.6,12.3-3.1 C402.8,181.7,399.8,210.3,374.4,210.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.4,98.5c0,0,13.1-32.8,53.4-24.9c0,0-37-24.3-62.7,19.6c0,0-36.9-17.3-91.9,6.5c0,0-51.7-18.2-91-7.9 c0,0-22.9-39.8-55.2-23.4c-32.3,16.4-15.4,54.2-9.8,64.1c0,0-53.5,54.5-33.4,121.8l10.8-13.4c0,0,15.4,73.4,55,96.5l2.4-18 c0,0,41.4,49.9,90,71.1c4.6,2.2,30.4,15,31.2,21.3v-34.9c0,0-33.7,2.8-42.7-12.8c-6.1-10.6-44.9-79.8-25.7-152.3 c0,0-18.7-2.8-22.2-34.3c0,0-13.9-6.8-31.2-5.4c0,0,30.9-9.7,59.9,1.5c29,11.2,36.8,39.8,56.4,27.2l5.4-80.5l5.9,80.5 c19.6,12.6,27.4-15.9,56.4-27.2c29-11.2,60-1.5,60-1.5s-12.4-8.7-32.3-12.7c-16.6-3.3-41,7.3-41,7.3s3.4-22.8,14.5-35 C397.2,121.2,418.8,118.9,425.4,98.5z M175.2,126.2c-1.2-11,12.7-21.8,12.7-21.8c-5.7-5.9-15.7-0.8-15.7-0.8c9-17.7,29.3-9,29.3-9 c-7.7-9.4-23.9-8.8-23.9-8.8C197.7,65.8,222,96.3,222,96.3C200.4,101.2,175.2,126.2,175.2,126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M283.6,200c-3.1-1-8.2,2.2-11.1,7.8c-9.6-2.8-12.9-13.2-12.5-23.1l0,0C267.6,188.3,276.5,194.5,283.6,200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378,207.8c-3-5.9-8.5-9.1-11.6-7.6c4.6-4.1,13.4-11.3,24.1-15.4h0C390.9,194.7,387.6,205.1,378,207.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMem);
export default __webpack_public_path__ + "static/media/MEM.f3110d5e2df579efcf21b8bbeb2f0dd8.svg";
export { ForwardRef as ReactComponent };